package org.example.newportfolio.utils

import com.varabyte.kobweb.silk.components.icons.fa.FaLinkedin
import com.varabyte.kobweb.silk.components.icons.fa.IconSize

object Res {

    object Strings {
        const val START_SECTION_TITLE = "Software Engineer - Android Developer"
        const val START_SECTION_SUBTITLE = "I’m a Native Android Developer, looking forward to helping people with my knowledge."
        const val START_SECTION_BUTTON_TEXT = "Explore my works"
        const val SCROLL_HINT = "Scroll"

        const val WORKS_SECTION_TITLE = "Explore my works"
        const val WORKS_SECTION_SUBTITLE = "All projects are primarily developed with Kotlin. It's a powerful cross-platform language and Google's preferred language for Android development."

        const val ABOUT_SECTION_TITLE = "About me"
        const val ABOUT_SECTION_SUBTITLE = "I'm Mohamed Elgohary, a dedicated Android developer skilled in Kotlin, Android Studio, and Git. I excel at turning designs into functional apps, work well both independently and in teams, and am committed to continuous learning."

        const val CONTACT_SECTION_TITLE = "Contact me"

        const val EMAIL_ADDRESS = "mohamed.abdelazim.elgohary@gmail.com"
        const val TELEGRAM_USERNAME = "@MohamedElgohary88"

        const val EMAIL_LINK = "mailto:$EMAIL_ADDRESS"
        const val GITHUB_LINK = "https://github.com/MohamedElgohary88"
        const val TELEGRAM_LINK = "https://t.me/MohamedElgohary88"
        const val LINKEDIN_LINK = "https://www.linkedin.com/in/mohamed-elgohary8"

        const val COPYRIGHT = "© 2024, Mohamed Elgohary"
    }

    object FontFamilies {
        const val POPPINS_REGULAR = "PoppinsRegular"
        const val POPPINS_MEDIUM = "PoppinsMedium"
    }

    object Images {
        const val LOGO_DARK = "images/logo_dark.svg"
        const val LOGO_LIGHT = "images/logo_light.svg"
        const val KOBWEB = "images/kobweb.png"

        const val START_IMAGE = "images/start_imagee.svg"

        const val ANDROID_STUDIO = "images/android_studio.svg"
        const val KOTLIN = "images/kotlin.svg"
        const val KTOR = "images/ktor.svg"
        const val FIGMA = "images/figma.svg"
        const val INTELLIJ_IDEA = "images/intellij_idea.svg"
        const val JAVA = "images/java.svg"
        const val FIREBASE = "images/firebase.svg"
        const val POSTGRESQL = "images/postgresql.svg"
        const val JETPACK_COMPOSE = "images/compose.svg"
        const val GITHUB_LIGHT = "images/github_light.svg"
        const val GITHUB_DARK = "images/github_dark.svg"
        const val MAIL_LIGHT = "images/mail_light.svg"
        const val MAIL_DARK = "images/mail_dark.svg"
        const val TELEGRAM_LIGHT = "images/telegram_light.svg"
        const val TELEGRAM_DARK = "images/telegram_dark.svg"
        const val LINKEDIN_LIGHT = "images/linkedin_light.svg"
        const val LINKEDIN_DARK = "images/linkedin_dark.svg"

        const val HONEY_MART = "images/hony.svg"
        const val TEAMIX = "images/teamix.svg"
        const val SKY_CAST = "images/weather.svg"
        const val MOVIE = "images/movie.svg"
        const val BLOG = "images/blog.svg"
        const val HOTEL = "images/hotel.svg"
    }

}